var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCollege = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7778 21V3.22222C18.7778 1.99492 17.7829 1 16.5556 1H5.44444C4.21715 1 3.22222 1.99492 3.22222 3.22222V21M18.7778 21L21 21M18.7778 21H13.2222M3.22222 21L1 21M3.22222 21H8.77778M7.66667 5.44442H8.77778M7.66667 9.88886H8.77778M13.2222 5.44442H14.3333M13.2222 9.88886H14.3333M8.77778 21V15.4444C8.77778 14.8308 9.27524 14.3333 9.88889 14.3333H12.1111C12.7248 14.3333 13.2222 14.8308 13.2222 15.4444V21M8.77778 21H13.2222",
    stroke: "#605E5E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCollege, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/college.3a0f7632.svg";
export { ForwardRef as ReactComponent };